module.exports = __webpack_public_path__ + "static/V-Class 2018-65268c1288f94e8370efcf95734486c5.jpg";